//
// Baseline style for most components
//
import { css } from "../../styled-components.mjs";

/* CSS migration: replace with "baseline" class */
export var rootStyle = function rootStyle() {
  return css(["box-sizing:border-box;-webkit-tap-highlight-color:transparent;"]);
};